import { Button, Col, Row } from 'antd';
import { AuthContext } from 'src/components/context/AuthContext';
import * as React from 'react';
import { IUser } from 'src/services/interfaces/UserInterface';



export function FacebookLoginButton(props: { onLoggedIn?: (user: IUser) => void }) {
    const authContext = React.useContext(AuthContext);

    return (
        <Button
            block
            style={{
                height: "48px",
                margin: "0px",
                backgroundColor: "#fff", color: "#000",
                maxWidth: "324px",
                fontSize: '16px',
                fontFamily: "Lato",
                fontWeight: 300,
                borderRadius: "30px",
                textTransform: 'uppercase'
            }}
            onClick={async () => {
                const user = await authContext.signInWithFacebook();
                if (props.onLoggedIn) {
                    props.onLoggedIn(user);
                }
            }}>
            <Row type="flex" align="middle" justify="center" style={{ maxHeight: "46px" }}>
                <Col xs={3} sm={3} md={3} lg={3} style={{ height: "46px"}}>
                    <span style={{ marginRight: "10px", paddingTop: "20px" }}>
                        <svg version="1.1" id="Capa_1" x="0px" y="0px" style={{ marginTop: "7px", paddingRight: "10px" }} viewBox="0 0 155.139 155.139" width="32px" height="32px"><g><g>
                            <path id="f_1_" d="M89.584,155.139V84.378h23.742l3.562-27.585H89.584V39.184   c0-7.984,2.208-13.425,13.67-13.425l14.595-0.006V1.08C115.325,0.752,106.661,0,96.577,0C75.52,0,61.104,12.853,61.104,36.452   v20.341H37.29v27.585h23.814v70.761H89.584z" data-original="#010002" className="active-path" data-old_color="#FDFCFD" fill="#4468b0" />
                        </g></g> </svg>
                    </span>
                </Col>
                <Col xs={21} sm={21} md={21} lg={21}>
                    Entrar com facebook
            </Col>
            </Row>
        </Button >
    )
}



// WEBPACK FOOTER //
// ./src/components/common/Facebook/FacebookLoginButton.tsx